import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = 'tc_session_id';

function getSessionId() {
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if (!s) {
      s = 'sess-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch { return ''; }
}

/**
 * Fires a POST /api/track on every route change to record pageviews.
 * Silently ignores admin routes and network errors.
 */
export default function useTracker() {
  const loc = useLocation();
  const lastRef = useRef('');

  useEffect(() => {
    const path = loc.pathname + (loc.search || '');
    if (path.startsWith('/admin')) return;          // skip admin
    if (path === lastRef.current) return;           // dedupe rapid updates
    lastRef.current = path;
    const referrer = document.referrer || '';
    // Fire-and-forget; do not block UI
    axios.post(`${API}/track`, { path, referrer, session_id: getSessionId() })
      .catch(() => { /* ignore */ });
  }, [loc.pathname, loc.search]);
}
